import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * SEO Component - Управління meta тегами для Google
 * 
 * Особливості:
 * - Динамічні title та description
 * - Canonical URL для уникнення дублікатів
 * - Structured Data (JSON-LD) для Google Rich Snippets
 * - Geo tags для локального SEO
 * 
 * @param {Object} props
 * @param {string} props.title - Заголовок сторінки (50-60 символів оптимально)
 * @param {string} props.description - Опис сторінки (150-160 символів)
 * @param {string} props.canonical - Канонічний URL сторінки
 * @param {Object} props.structuredData - Structured data для Google (Schema.org)
 * @param {boolean} props.noindex - Чи додавати noindex, nofollow (для адмін сторінок)
 */
const SEO = ({
    title,
    description = 'UnionAuto - інтернет-магазин якісних б/у автозапчастин з Європи. Широкий асортимент, доступні ціни, швидка доставка. Оригінальні деталі для вашого автомобіля.',
    canonical,
    structuredData,
    noindex = false,
    noSuffix = false,
}) => {
    const fullTitle = noSuffix
        ? (title || 'UnionAuto - Автозапчастини в Україні')
        : (title ? `${title} | UnionAuto` : 'UnionAuto - Автозапчастини в Україні');
    
    // Базовий URL сайту
    const siteUrl = typeof window !== 'undefined' ? window.location.origin : 'https://union-auto.com.ua';
    
    // Повний URL canonical
    const fullCanonical = canonical ? `${siteUrl}${canonical}` : typeof window !== 'undefined' ? window.location.href : siteUrl;

    return (
        <Helmet>
            {/* Основні meta теги для Google */}
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            
            {/* Canonical URL - важливо для SEO */}
            <link rel="canonical" href={fullCanonical} />
            
            {/* Geo теги для локального SEO */}
            <meta name="geo.region" content="UA" />
            <meta name="geo.placename" content="Україна" />
            
            {/* Robots meta - керування індексацією */}
            <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"} />
            
            {/* Structured Data (JSON-LD) для Google Rich Snippets */}
            {structuredData && (
                Array.isArray(structuredData) ? (
                    structuredData.map((data, index) => (
                        <script key={index} type="application/ld+json">
                            {JSON.stringify(data)}
                        </script>
                    ))
                ) : (
                    <script type="application/ld+json">
                        {JSON.stringify(structuredData)}
                    </script>
                )
            )}
        </Helmet>
    );
};

export default SEO;

